import Model from './table_main.model'

let storeContent = utils.generateStore({
   Model,
   table_mains: [],
   selected_table_mains: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addTableMain(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'insert',
                  data: {
                     record: {
                        is_accessible: data.is_accessible,
                        is_db_configured: data.is_db_configured,
                        alias: data.alias,
                        unique_field: data.unique_field,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "table_main",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchTableMain')
               ctx.commit('show_create_modal', false)
               $notify('success', 'Table Main Created', `Table Main ${data.name} successfully created.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updateTableMain(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_table_mains[0]._id,
                     record: {
                        is_accessible: data.is_accessible,
                        is_db_configured: data.is_db_configured,
                        alias: data.alias,
                        unique_field: data.unique_field,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "table_main",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchTableMain')
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Table Main Updated', `Table Main ${data.name} successfully updated.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteTableMain(ctx, payload) {
         try {
            ctx.commit('loading', true)

            for (const table_main of ctx.getters.selected_table_mains) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: table_main._id,
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "table_main",
                  }
               })
            }

            await ctx.dispatch('fetchTableMain')
            ctx.commit('show_delete_modal', false)
            $notify('success', 'Table Main Deleted', `<b>${ctx.getters.selected_table_mains.length}</b> Table Main successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'table_main:edit') {
            let Model = ctx.getters.Model
            Model.forms.editTableMain.data = payload.rows[0]

            ctx.commit('Model', Model)
            ctx.commit('show_edit_modal', true)
            ctx.commit('selected_table_mains', payload.rows)
         } else if (payload.action === 'table_main:delete') {
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Table Main`)
            ctx.commit('show_delete_modal', true)
            ctx.commit('selected_table_mains', payload.rows)
         } else if (payload.action === 'table_main:view') {
            // $session.set('selected_table_mains',payload.rows[0])
         }
      },
      async fetchTableMain(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "table_main",
               }
            })
            ctx.commit('table_mains', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            let res = null,
               Model = ctx.getters.Model

            // Fetch Schema
            res = await api.fetchEndpointSecure({ resource: 'commons', action: 'list', data: { rules: { match: { is_to_extract_data: true } } }, meta_data: { service: "analytics", collection: "schema" } })
            Model = utils.appendSelectData({ Model, forms: ['filter_tables'], model: 'schema', label: 'name', dataField: 'code', data: res.result.records })


            ctx.commit('Model', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchTableMain')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};